import { render, staticRenderFns } from "./Model3DViewerNew.vue?vue&type=template&id=4fcf6b59"
import script from "./Model3DViewerNew.vue?vue&type=script&lang=js"
export * from "./Model3DViewerNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports